
import { Box, Button } from '@material-ui/core'

import { getIsLocalPortDevMode, getUnauthedFallbackUrl } from 'common/api'
import { getParams } from 'common/click-tracking-params'
import { useIsAuthed } from 'components/AuthShield'

const LoginButton = (props: any) => {
  const isAuthed = useIsAuthed()
  const isLocalPortDevMode = getIsLocalPortDevMode()
  const params = getParams('Log In', 'L1')
  return isAuthed ? null : (
    <Box
      width="100%"
      whiteSpace="nowrap"
      mr={1}
    >
      <Button
        {...props}
        size="large"
        component="a"
        color="primary"
        href={isLocalPortDevMode ? getUnauthedFallbackUrl() : `/signin?${params}`}
        aria-label="Log in to Scoir"
        rel="noopener noreferrer"
      >
        Log In
      </Button>
    </Box>
  )
}

export default LoginButton
